import { Category } from "../../category/category";
import { Expense } from "../../expense/expense";

export class responseSaveExpense {
    category: Category;
    expense: Expense;
    stats: any;
    constructor(data) {
        this.category = data.category;
        this.expense = data.expense;
        this.stats = data.stats;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/http/res/response-save-expense.ts